(() => {
  if (!document.body.classList.contains('gl2-indoor-cards')) return;
  const scope = document.querySelector('.main-content');
  if (!scope) return;
  const selector = '.boost-sd__product-item flair-badges';
  const stockLabel = document.querySelector('script[data-gl2-stock-label]')?.dataset.gl2StockLabel;
  const watched = new Map();
  let pending = false;
  const palettes = {
    new: ['#f3efe5', '#615841'],
    'special variety': ['#e8eee4', '#3f5745'],
    'out of stock': ['#eeece7', '#5e625e']
  };

  function decorate(host) {
    const root = host.shadowRoot;
    if (!root) return;
    if (!watched.has(host)) {
      const observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      watched.set(host, observer);
    }
    root.querySelectorAll('flair-item').forEach(item => {
      const label = item.shadowRoot?.querySelector('.c')
        || item.querySelector('template')?.content.querySelector('.c');
      const key = label?.textContent.trim().toLowerCase();
      const isStock = key === 'out of stock' || (stockLabel && key === stockLabel.toLowerCase());
      const palette = palettes[isStock ? 'out of stock' : key];
      if (!palette) return;
      if (isStock && stockLabel && label.textContent !== stockLabel) label.textContent = stockLabel;
      item.style.setProperty('--flair-background', palette[0]);
      item.style.setProperty('--flair-color', palette[1]);
    });
  }

  function refresh() {
    pending = false;
    watched.forEach((observer, host) => {
      if (!host.isConnected) {
        observer.disconnect();
        watched.delete(host);
      }
    });
    scope.querySelectorAll(selector).forEach(decorate);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    queueMicrotask(refresh);
  }

  Promise.all([
    customElements.whenDefined('flair-badges'),
    customElements.whenDefined('flair-item')
  ]).then(() => {
    refresh();
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches(selector) || node.querySelector(selector)
        )
      ) || Array.from(record.removedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches(selector) || node.querySelector(selector)
        )
      ))) schedule();
    }).observe(scope, { childList: true, subtree: true });
  });
})();
